import {AdGroupForm} from 'common/pages/ad-group/AdGroupForm'

export const AdGroupAdvForm = (props) =>
    <AdGroupForm {...props} mode={props.mode} agency={false} />